// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Jh1Y","col":"styles_col__1St48"};